import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors } = theme;

export default createUseStyles(
  {
    placeholder: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      overflow: 'hidden',
      color: colors.textOnColorPrimary,
      background: 'linear-gradient(137.24deg, #009ACE 0%, #004B70 100%);', // TODO: !!! TOKEN !!! CPF-415
      font: theme.typography.tpHeading03,
      fontSize: ({ size }: { size: number }) => size * 0.46,
    },

    img: {
      display: 'inline-block',
      borderRadius: '50%',
      overflow: 'hidden',
    },

    fallback: {
      extend: 'img',
      color: colors.backgroundAccent,
    },
  },
  {
    name: 'Avatar',
  },
);
